import React, { memo, useState } from 'react';

const CopyText = ({ text, style, textClassName = undefined, iconClassName = undefined }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 600);
    } catch (error) {
      setIsCopied(false);
      console.error('Unable to copy text: ', error);
    }
  };

  return (
    <div title="Click to Copy" className="position-relative cursor-pointer" style={style}>
      <span className={textClassName}>{text}</span>
      {text && (
        <i
          className={`pl-1 fa fa-clone text-secondary-200 ${iconClassName}`}
          aria-hidden="true"
          onClick={copyToClipboard}
        />
      )}
      {isCopied && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: '20%',
            right: '20%',
            margin: '0 auto',
            background: 'rgba(0, 0, 0, 0.7)',
            color: 'white',
            padding: '5px',
            borderRadius: '5px',
            textAlign: 'center',
            width: '70px'
          }}
        >
          Copied!
        </div>
      )}
    </div>
  );
};

CopyText.displayName = 'CopyText';
export default memo(CopyText);
